import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Loading</h2>
          <p className="auth-subtitle">Verifying your authentication status</p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location, message: "Please log in to access this page" }} replace />;
  }

  return children;
};

export default ProtectedRoute;